export default __webpack_public_path__ + "static/media/Subtitels-Wives.bb0b853e.png";